import Link from 'next/link';
import Icon from '../Icon';
import { normalizeEther } from '../../helpers/digits';
import { useState, useEffect } from 'react';
import { ChainIcon } from '../Icon';
import { getTokenName } from '../../helpers/getChainName';

const CollectionMetrics = ({ collectionMetric, treasuryValue }) => {
  const IconChain = () => (
    <div>
      <ChainIcon
        name={collectionMetric?.chain}
        tooltip={getTokenName(collectionMetric?.chain)}
        sideGap
        width={16}
      />
    </div>
  );

  const [length, setLength] = useState(0);
  const metrics = [
    { name: 'Items', value: collectionMetric?.itemCount ?? 0 },
    { name: 'Owners', value: collectionMetric?.ownerCount ?? 0 },
    {
      name: 'Floor Price',
      value: () => (
        <>
          <IconChain />
          {collectionMetric?.floorPrice || '-'}
        </>
      ),
    },
    {
      name: 'Volume Traded',
      value: () => (
        <>
          <IconChain />
          {collectionMetric?.volumeTraded?.toFixed(4) || 0}
        </>
      ),
    },
    {
      name: 'Top Global Bid',
      value: () => (
        <>
          <IconChain />
          {collectionMetric?.topGlobalBid || '-'}
        </>
      ),
      disabled: !collectionMetric?.topGlobalBid || collectionMetric?.topGlobalBid == 0,
    },
    // {
    //   name: 'Top Lending Offer',
    //   value: () => (
    //     <>
    //       <IconChain />
    //       {collectionMetric?.topLendingOffer || '-'}
    //     </>
    //   ),
    //   disabled: !collectionMetric?.topLendingOffer || collectionMetric?.topLendingOffer == 0,
    // },
    {
      name: 'Treasury Value',
      value: () => (
        <>
          <Icon name={'icon-treasury'} />
          {('' + treasuryValue).substring(0, 10)}
        </>
      ),
      disabled: treasuryValue == 0,
    },
  ];

  useEffect(() => {
    setLength(metrics.filter(({ disabled }) => !disabled).length - 1);
  }, [metrics]);

  return (
    <div
      className={[
        'rounded-xl flex w-full min-w-[360px]',
        'divide-x divide-jacarta-100 border border-jacarta-100 bg-white',
        'dark:divide-jacarta-600 dark:border-jacarta-600 dark:bg-jacarta-800',
      ].join(' ')}
    >
      {metrics.map(
        ({ name, value, disabled }, index) =>
          !disabled && (
            <div
              className='block h-[52px] w-full py-[10px] text-center'
              key={`${collectionMetric?.id ?? 'item'}-${name}-${index}`}
            >
              <Link href='#'>
                <a
                  className={
                    'hover:shadow-md' +
                    (index === 0 ? ' rounded-l-xl' : '') +
                    (index === length ? ' rounded-r-xl' : '')
                  }
                >
                  <div className='mx-1 flex items-center justify-center text-sm font-normal text-jacarta-700 dark:text-white'>
                    {typeof value == 'function' ? value() : value}
                  </div>

                  {name && name.length > 10 ? (
                    <div className='bounce overflow-hidden text-center text-2xs font-medium tracking-tight dark:text-jacarta-400 lg:block'>
                      <p
                        className={[
                          'px-[4px]',
                          ('' + name).length > 10 ? 'bounce-20' : '',
                          ('' + name).length > 20 ? 'bounce-40' : '',
                          ('' + name).length > 30 ? 'bounce-60' : '',
                          ('' + name).length > 40 ? 'bounce-80' : '',
                          ('' + name).length > 50 ? 'bounce-100' : '',
                        ].join(' ')}
                      >
                        {name}
                      </p>
                    </div>
                  ) : (
                    <div className='overflow-hidden text-center text-2xs font-medium tracking-tight dark:text-jacarta-400 lg:block'>
                      {name}
                    </div>
                  )}
                  {/* <div className='block text-center text-2xs font-medium tracking-tight dark:text-jacarta-400 lg:hidden'>
                    {name
                      ?.split(' ')
                      .map((x) => x?.substring(0, 1).concat('.'))
                      .join(' ')}
                  </div> */}
                </a>
              </Link>
            </div>
          ),
      )}
    </div>
  );
};

export default CollectionMetrics;
